import { Model } from "vue-mc";

export class Vendor extends Model {
  defaults() {
    return {
      clave: null
      , descripcion: ""
      , canales: ""
      , rep: ""
      , email: []
      , status: true
      , emailFacturacion: ""
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , descripcion: (descripcion) => descripcion
      , canales: (canales) => canales
      , rep: (rep) => rep
      , email: (email) => email
      , status: (status) => status
      , emailFacturacion: (emailFacturacion) => emailFacturacion
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/operativos/vendor.js